import { AppUtils } from '../../utils/index';

import { BaseApiModel } from './BaseApiModel';
import { MglArtApi } from './PersonMglArtApi';

/**
 * APIL Url: ADAC.Internet.Types.Person.ContractInfo
 * 
 * Endpoints: /api/Identity, /api/MglTarif, /api/MglTarif/tarifliste, /api/MglTarif/tarifempfehlung
 */
export class ContractInfoApi extends BaseApiModel {
	constructor(initialProperties?: Partial<ContractInfoApi>) {
		super();
		if (initialProperties) {
			AppUtils.Helper.mapObject(initialProperties, this);
		}
	}

	protected tarif: MglArtApi;
	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	get Tarif(): MglArtApi {
		return this.tarif;
	}

	/**
	 * Description: 
	 * APIL Type: ADAC.Internet.Types.Person.MglArt
	 */
	set Tarif(value: MglArtApi) {
		this.tarif = value;
	}

	protected tarifCode: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get TarifCode(): string {
		return this.tarifCode;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set TarifCode(value: string) {
		this.tarifCode = value;
	}

	protected tarifCodeId: number;
	/**
	 * Description: 
	 * APIL Type: int32
	 */
	get TarifCodeId(): number {
		return this.tarifCodeId;
	}

	/**
	 * Description: 
	 * APIL Type: int32
	 */
	set TarifCodeId(value: number) {
		this.tarifCodeId = value;
	}

	protected tarifmerkmalMitgliedschaft: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get TarifmerkmalMitgliedschaft(): string {
		return this.tarifmerkmalMitgliedschaft;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set TarifmerkmalMitgliedschaft(value: string) {
		this.tarifmerkmalMitgliedschaft = value;
	}

	protected beitrag: number;
	/**
	 * Description: 
	 * APIL Type: double
	 */
	get Beitrag(): number {
		return this.beitrag;
	}

	/**
	 * Description: 
	 * APIL Type: double
	 */
	set Beitrag(value: number) {
		this.beitrag = value;
	}

	protected beitragAlt: number;
	/**
	 * Description: 
	 * APIL Type: double
	 */
	get BeitragAlt(): number {
		return this.beitragAlt;
	}

	/**
	 * Description: 
	 * APIL Type: double
	 */
	set BeitragAlt(value: number) {
		this.beitragAlt = value;
	}

	protected beschreibung: string;
	/**
	 * Description: 
	 * APIL Type: string
	 */
	get Beschreibung(): string {
		return this.beschreibung;
	}

	/**
	 * Description: 
	 * APIL Type: string
	 */
	set Beschreibung(value: string) {
		this.beschreibung = value;
	}

	protected hatPartner: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get HatPartner(): boolean {
		return this.hatPartner;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set HatPartner(value: boolean) {
		this.hatPartner = value;
	}

	protected familienverbund: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Familienverbund(): boolean {
		return this.familienverbund;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Familienverbund(value: boolean) {
		this.familienverbund = value;
	}

	protected schwerbehindert: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get Schwerbehindert(): boolean {
		return this.schwerbehindert;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set Schwerbehindert(value: boolean) {
		this.schwerbehindert = value;
	}

	protected inAusbildung: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get InAusbildung(): boolean {
		return this.inAusbildung;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set InAusbildung(value: boolean) {
		this.inAusbildung = value;
	}

	protected plusMitglied: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get PlusMitglied(): boolean {
		return this.plusMitglied;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set PlusMitglied(value: boolean) {
		this.plusMitglied = value;
	}

	protected alterTarif: boolean;
	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	get AlterTarif(): boolean {
		return this.alterTarif;
	}

	/**
	 * Description: 
	 * APIL Type: boolean
	 */
	set AlterTarif(value: boolean) {
		this.alterTarif = value;
	}

	/**
	 * Creates a new model object and copies the values from the provided data object (or other application model) to the created model.
	 */
	public static createFromObject(dataObject: { [key: string]: any }): ContractInfoApi {
		return AppUtils.Helper.createFromMap(dataObject, ContractInfoApi, (key, value) => {
			switch (key.toLowerCase()) {

				default:
					return value;
			}
		});
	}

	public toRequestObject(): { [key: string]: any } {
		const result: { [key: string]: any } = {};
		result.Tarif = this.tarif;
		result.TarifCode = this.tarifCode;
		result.TarifCodeId = this.tarifCodeId;
		result.TarifmerkmalMitgliedschaft = this.tarifmerkmalMitgliedschaft;
		result.Beitrag = this.beitrag;
		result.BeitragAlt = this.beitragAlt;
		result.Beschreibung = this.beschreibung;
		result.HatPartner = this.hatPartner;
		result.Familienverbund = this.familienverbund;
		result.Schwerbehindert = this.schwerbehindert;
		result.InAusbildung = this.inAusbildung;
		result.PlusMitglied = this.plusMitglied;
		result.AlterTarif = this.alterTarif;
		return result;
	}

	public toJsonString(): string {
		return JSON.stringify(this.toRequestObject());
	}
}